import Button from "@components/Button"
import Layout from "@components/Layout"
import { useTranslation } from "react-i18next"
import { Form, useSubmit } from "react-router-dom"

interface FeedbackPageProps {
  emoji: string
  titleKey: string
  textKey: string
  points?: string[]
  buttonKey?: string
}

export default function FeedbackPage({
  emoji,
  titleKey,
  textKey,
  points,
  buttonKey,
}: FeedbackPageProps) {
  const { t } = useTranslation()
  const submit = useSubmit()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    submit(event.currentTarget)
  }

  const translatedPoints = points?.map((point) => t(point))

  return (
    <Layout>
      <div className="flex grow flex-col items-center justify-center px-4">
        <div className="mb-6 text-6xl">{emoji}</div>

        <h1 className="custom-heading mb-4">{t(titleKey)}</h1>

        <p className="mb-6 max-w-sm text-center leading-relaxed text-gray-500">
          {t(textKey)}
        </p>

        {translatedPoints && (
          <div className="w-full max-w-sm space-y-3">
            {translatedPoints.map((point, index) => (
              <div
                key={index}
                className="flex items-center gap-3 rounded-2xl bg-white px-5 py-4"
              >
                <div className="bg-custom-teal flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm font-bold text-white">
                  {index + 1}
                </div>
                <p className="text-custom-charcoal text-sm font-semibold">
                  {point}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="sticky bottom-0 -mx-5 bg-gradient-to-t from-white from-70% to-transparent px-5 pt-8 pb-4">
        <Form method="post" onSubmit={handleSubmit}>
          <input
            name={t(titleKey, { lng: "en" })}
            type="hidden"
            value={t("shared.continue", { lng: "en" })}
          />
          <Button
            title={buttonKey ? t(buttonKey) : t("shared.continue")}
            type="submit"
          />
        </Form>
      </div>
    </Layout>
  )
}
